"use_strict"

class MainMenu {

	constructor () {
		this._menu = document.getElementById('menu-main');

		if ( !this._menu ) return;

		this._addClassesForA11yPlugin();
	}

	/**
	 * @function _addClassesForA11yPlugin
	 * @desc Add the necessary classes to the menu to enable on it the jQuery "A11y navigation" plugin.
	 * More info : https://a11y.nicolas-hoffmann.net/carrousel/
	 */
	_addClassesForA11yPlugin () {
		let menu      = this._menu,
			menuItems = menu.children,
			submenus  = menu.querySelectorAll('.sub-menu');

		menu.classList.add('js-nav-system');

		for ( let i = 0; i < menuItems.length; i++) {
			menuItems[i].classList.add('js-nav-system__item');
			menuItems[i].firstChild.classList.add('js-nav-system__link');
		}

		for ( let j = 0; j < submenus.length; j++) {
			submenus[j].classList.add('js-nav-system__subnav');

			for ( let k = 0; k < submenus[j].children.length; k++) {
				submenus[j].children[k].classList.add('js-nav-system__subnav__item');
				submenus[j].children[k].firstChild.classList.add('js-nav-system__subnav__link');
			}
		}
	}
}

export { MainMenu }
